import * as a from "react";
import { Primitive as o } from "../../../../../@radix-ui_react-primitive@2.1.3_@types_react-dom@19.2.3_@types_react@19.2.14__@types_re_1181ea5061ec9212248424669240e4ec/bundled_deps/@radix-ui/react-primitive/dist/index.js";
import { j as t } from "../../../../../../../_virtual/jsx-runtime.js";
var d = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), s = "VisuallyHidden", e = a.forwardRef(
  (r, i) => /* @__PURE__ */ t.jsx(
    o.span,
    {
      ...r,
      ref: i,
      style: { ...d, ...r.style }
    }
  )
);
e.displayName = s;
var n = e;
export {
  n as Root,
  d as VISUALLY_HIDDEN_STYLES,
  e as VisuallyHidden
};
